import React from 'react';

import { Stack } from '@atlaskit/primitives/compiled';

import type { PlanNode } from '../../../common/types';
import { Entities } from '../../../common/ui/entities/Entities';
import { IntentBody } from '../../../common/ui/intent-body/IntentBody';

import { ActionCardWrapper } from './ActionCardWrapper';

const getBorderOverride = (isFirst: boolean, isLast: boolean) => {
	if (isFirst && isLast) {
		return 'both';
	}
	if (isFirst) {
		return 'top';
	}
	if (isLast) {
		return 'bottom';
	}

	return undefined;
};

export const SubPlan = ({
	plan,
	isFirst,
	isLast,
	number,
}: {
	plan: PlanNode;
	isFirst: boolean;
	isLast: boolean;
	number: number;
}): React.JSX.Element => {
	const { title, subtext } = plan.payload;
	const borderOverride = getBorderOverride(isFirst, isLast);
	const hasEntities =
		(plan.payload.entities?.fields !== undefined && plan.payload.entities.fields.length > 0) ||
		(plan.payload.entities?.spaces !== undefined && plan.payload.entities.spaces.length > 0) ||
		(plan.payload.entities?.workTypes !== undefined && plan.payload.entities.workTypes.length > 0);
	const hasIntentBody =
		plan.steps.length === 1 ||
		(plan.steps.length > 0 && plan.steps.every((step) => step.actionSubject === 'field-options'));
	const isExpandable = hasIntentBody || hasEntities;

	return (
		<ActionCardWrapper
			title={title}
			subtitle={subtext}
			index={number}
			borderOverride={borderOverride}
			isExpandable={isExpandable}
			isSubPlan
		>
			{isExpandable && (
				<Stack space="space.050">
					{hasEntities && <Entities entities={plan.payload.entities} />}
					{hasIntentBody && <IntentBody steps={plan.steps} />}
				</Stack>
			)}
		</ActionCardWrapper>
	);
};
